import React from 'react'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { TwoColumn } from '@/components/frontend/atoms/layout/TwoColumn'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { ButtonLink } from '@/components/frontend/atoms/navigation/ButtonLink'
import { SectionIntro } from '@/components/frontend/molecules/SectionIntro'
import { FAQItem } from '@/components/frontend/molecules/FAQItem'
import { useTranslation } from '@/hooks/useTranslation'

const QUESTIONS = ['cost', 'timeline', 'companies', 'data', 'after'] as const

export const FAQSection: React.FC = () => {
  const { t, lp } = useTranslation()

  return (
    <Section padding="lg" background="alt" id="faq">
      <Container>
        <TwoColumn split="narrow-wide" gap="12" alignItems="start">
          <Stack gap="6" align="start">
            <SectionIntro label={t('faq.label')} title={t('faq.heading')} subtitle={t('faq.subheading')} />
            <ButtonLink href={lp('/#contatti')} variant="secondary" arrow>{t('nav.book_call')}</ButtonLink>
          </Stack>
          <Stack gap="0">
            {QUESTIONS.map((key, index) => (
              <FAQItem key={key} question={t(`faq.${key}_q`)} answer={t(`faq.${key}_a`)} defaultOpen={index === 0} />
            ))}
          </Stack>
        </TwoColumn>
      </Container>
    </Section>
  )
}
